import { Box, ListItemText, Skeleton, Typography, useTheme } from "@mui/material"
import { PropertyBox } from "lib/@components/property-box"
import { useState } from "react"
import { DifferenceWrapper } from "routes/schedule/compare/differenceWrapper"
import { taskLabel } from "routes/schedule/compare/task-label"
import { useCommitFunction } from "routes/schedule/compare/use-commit-function"
import { StatusButton } from "routes/schedule/compare/status"
import { ListItemBox } from "lib/@components/ListItemBox"
import { useMeasurement } from "lib/@hooks/useMeasurement"
import { Bound } from "lib/@components/binding/Bound"
import { Task } from "routes/schedule/tasks/task"
import { Approved } from "routes/schedule/compare/approved"

export function NewTask({ task }) {
    const [remove, setRemoved] = useState(false)
    const [{ width }, attach] = useMeasurement()
    useCommitFunction(
        (target) => {
            target.tasks.splice(
                target.tasks.findIndex((t) => t.id === task.id),
                1
            )
        },
        remove,
        [task]
    )
    const [hover, setHover] = useState(false)
    const theme = useTheme()

    return (
        <Bound alwaysOpenTask={true}>
            <PropertyBox spacing={0}>
                <DifferenceWrapper
                    label={`${remove ? "Removed" : ""} New ${taskLabel(task)} "${task.title}"`}
                    wrapper={<Box sx={{ p: 1 }} />}
                >
                    <ListItemBox ml={-1}>
                        <ListItemText
                            disableTypography
                            sx={{ flex: 1, pl: 0 }}
                            data-cy="new-task-left-panel"
                            primary={
                                <Box
                                    sx={{
                                        "& *": { textDecoration: remove ? "line-through !important" : "" },
                                        opacity: hover ? 0.25 : 1,
                                        transition: "opacity 0.2s linear",
                                    }}
                                >
                                    <Bound editMode={false}>
                                        <Task last={true} item={task} index={0} />
                                    </Bound>
                                </Box>
                            }
                            secondary={
                                <Typography variant="body2" sx={{ textTransform: "capitalize" }}>
                                    {remove ? `${taskLabel(task)} removed` : `${taskLabel(task)} added`}
                                </Typography>
                            }
                        />
                        <Approved width={8}>
                            <StatusButton
                                onHover={setHover}
                                copied={remove}
                                copy={() => setRemoved(!remove)}
                                revert={() => setRemoved(!remove)}
                            />
                            <Box
                                flex={1}
                                ref={attach}
                                position="relative"
                                sx={{
                                    borderRadius: 1,
                                    transition: "background-color linear 0.2s",
                                    bgcolor: hover ? `${theme.palette.primary.main}20` : undefined,
                                }}
                                data-cy="new-task-right-panel"
                            >
                                <Skeleton
                                    variant="rectangular"
                                    width={width}
                                    sx={{ minWidth: 180 }}
                                    animation={false}
                                    height={110}
                                />
                                <Box
                                    position="absolute"
                                    left="50%"
                                    top="50%"
                                    sx={{
                                        transform: "translate3d(-50%, -50%, 0)",
                                        color: "text.secondary",
                                        opacity: remove ? 0.5 : 1,
                                    }}
                                >
                                    Not Found In This Version
                                </Box>
                            </Box>
                        </Approved>
                    </ListItemBox>
                </DifferenceWrapper>
            </PropertyBox>
        </Bound>
    )
}
